export default __webpack_public_path__ + "static/media/feature-6.e50444b8.svg";